import { DOCUMENT_TYPE } from 'app/helpers/documentTypes';
import { productsActionType } from './productsActionType';
import { EPersonFunctionProduct } from 'modules/customer/context/PersonProvider/person.interfaces';
import { Condition } from 'modules/customer/context/CustomerProvider/customer.interfaces';
import { ConsigneeOrganType } from 'modules/products/pages/ApplicationRequest/ConsignedStep/interfaces';
import { TacValueType } from 'modules/products/pages/ApplicationRequest/SimulationV2Step/CreditSimulatorV2/types';

export enum TypeProductEmission {
  BILLET_PAYMENT = 'BILLET_PAYMENT',
  COMMERCIAL_PAPER = 'COMMERCIAL_PAPER',
  CCB = 'CCB',
  QRCODE_PIX = 'QRCODE_PIX',
  CONSIGNED = 'CONSIGNED',
}

export type TProductVariableConfiguration = {
  description: string | null;
  display_name: string | null;
  id: string | null;
  name: string;
  required: boolean;
  type: string | null;
};

export type TProductDocumentConfiguration = {
  required: boolean;
  type: DOCUMENT_TYPE;
};

export type TProductQualificationRequest = {
  borrower?: {
    id: string;
  };
  employer?: {
    id: string;
  };
  funding: {
    id: string;
  };
  role: string;
  condition?: Condition;
};

export enum EBeneficiaryType {
  BORROWER = 'BORROWER',
  EXTERNAL_UNREGISTERED_ACCOUNT = 'EXTERNAL_UNREGISTERED_ACCOUNT',
  EXTERNAL_REGISTERED_ACCOUNT = 'EXTERNAL_REGISTERED_ACCOUNT',
  CONSIGNED = 'CONSIGNED',
  SPLIT_DISBURSEMENT = 'SPLIT_DISBURSEMENT',
  MULTISPLIT = 'MULTISPLIT',
}

export type TProducts = {
  additional_interest?: string | null;
  agreement_template?: { id: string };
  allow_disbursement_in_window?: boolean;
  allow_disbursement_on_sign?: boolean;
  allowed_signature_providers?: string[];
  amortization_type?: string;
  amortization_variation?: string;
  beneficiary_type: EBeneficiaryType;
  borrower_type?: string;
  conditions_required?: boolean;
  created_at?: string;
  custom_ccb_template_required?: boolean;
  custom_simulator?: string;
  description?: string;
  financed_iof?: boolean;
  fine_rate?: string;
  funding_signature_required?: boolean;
  id: string;
  interest_compounding_type?: string;
  interest_type?: string;
  iof_zero?: boolean;
  max_interest_rate?: number;
  max_num_payments?: number;
  min_interest_rate?: number;
  min_num_payments?: number;
  multiple_disbursements_dates?: boolean;
  name: string;
  organ_type?: ConsigneeOrganType;
  originator_signature_required?: boolean;
  qualification_required?: boolean;
  regulator_product_code?: string;
  schedule_type?: string;
  status?: string;
  sub_type?: string;
  tac_not_included_cession_amount?: boolean;
  total_amount_applications?: number;
  total_applications?: number;
  type_product_emission?: TypeProductEmission;
  updated_at?: string;
  insurance_configuration?: {
    amount_financed: boolean;
    fixed: number | null;
    limit: number | null;
    max: number | null;
    max_or_fixed_present: boolean;
    min_not_greater_than_max: boolean;
    min: number | null;
    type: 'MONETARY' | 'PERCENTAGE';
  } | null;
  tac_configuration?: {
    min: number;
    max: number;
    type: TacValueType;
    limit: number | null; // sempre valor monetary
    fixed: number | null; // se vier o fixed, desconsiderar o que vier de min e max
  };
  variables_configuration?: {
    application: TProductVariableConfiguration[];
    [EPersonFunctionProduct.BORROWER]: {
      business: TProductVariableConfiguration[];
      business_document: TProductDocumentConfiguration[];
      person: TProductVariableConfiguration[];
      person_document: TProductDocumentConfiguration[];
    };
    [EPersonFunctionProduct.CO_SIGNER]: {
      business: TProductVariableConfiguration[];
      business_document: TProductDocumentConfiguration[];
      person: TProductVariableConfiguration[];
      person_document: TProductDocumentConfiguration[];
    };
    employer: TProductVariableConfiguration[];
    employer_document: TProductDocumentConfiguration[];
    [EPersonFunctionProduct.GUARANTOR]: {
      business: TProductVariableConfiguration[];
      business_document: TProductDocumentConfiguration[];
      person: TProductVariableConfiguration[];
      person_document: TProductDocumentConfiguration[];
    };
  };
};

export interface IProductsState {
  content: TProducts[];
  has_next?: boolean;
  total_elements?: number;
  total_pages?: number;
}

export type IDispatch = (action: IProductsAction) => void;

export interface IProductsContext {
  state: IProductsState;
  dispatch: IDispatch;
}

export type IProductsAction =
  | {
      type: productsActionType.SET_PRODUCTS;
      payload: IProductsState;
    }
  | {
      type: productsActionType.SET_PRODUCT;
      payload: TProducts;
    };
